import { Flow_0_0_2, getData, getFullItemOne, getFullItemTwo } from '@flexus/core';
import { filter, map, pluck, skipWhile, switchMap, take } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { GetDecoderSerialNumberDisplay } from '../../../../mul-sp/configs/reusable/dataManipulations';

export const MUL_VIEW_JOB_SUMMARY: Flow_0_0_2 = {
	id: 'JobSummary',
	itemType: 'flow',
	name: 'View Job Summary',
	excludeForOnlyStates: [20, 196],
	header: {
		title: (store, bf) => {
			return store.select(getFullItemOne).pipe(
				skipWhile(x => !x),
				map(itemOne => {
					if (itemOne && itemOne?.applicant && itemOne?.applicant?.information) {
						return `Summary for this job on policy - ${itemOne?.loan_information?.mavenclaimnumber}  -  ${itemOne?.applicant?.surname}`;
						// return `Job Summary : ${itemOne?.loan_information?.mavenclaimnumber}  -  ${itemOne?.applicant?.surname}`;
					} else {
						return 'Job Summary';
					}
				})
			);
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	startNode: 'JobSummary',
	instructions: {
		editRoles: {
			0: ''
		},
		viewRoles: {
			0: ''
		}
	},
	actionPanel: instance => {
		return () => {
			return [{}];
		};
	},
	nodes: {
		JobSummary: {
			component: {
				children: [
					{
						component: 'JobSummaryComponent',
						inputs: { title: 'Job Information', assessorName$: 'assessorName', teamLead$: 'teamLeader', extras$: 'decoderInfoKeyValues' }
					}
				]
			},
			serverCalls: {
				assessorName: {
					errorMessage: 'Something went wrong with claim information!',
					directCall: (http, store, sq) => {
						return store.select(getFullItemTwo).pipe(
							filter(x => !!x),
							take(1),
							pluck('assessor'),
							switchMap(assessor => {
								return of('Not Assigned');
							})
						);
					}
				},
				teamLeader: {
					errorMessage: 'Something went wrong with claim information!',
					directCall: (http, store, sq) => {
						return store.select(getFullItemTwo).pipe(
							filter(x => !!x),
							take(1),
							pluck('team_leader'),
							switchMap(team_leader => {
								if (!team_leader) {
									return of('No team lead assigned');
								} else {
									return of(team_leader?.full_name);
								}
							})
						);
					}
				},
				voucher: {
					serviceVariable: 'mulService',
					functionName: 'getVoucherInfo',
					responseSlice: 'payload',
					errorMessage: 'Could not get voucher from server!',
					followUpSuccessCalls: {
						decoderInfoKeyValues: {
							errorMessage: 'unable to add extra info to itemTwo',
							directCall: (http, store) => {
								return forkJoin([
									store.select(getFullItemTwo).pipe(
										skipWhile(itt => !itt),
										take(1),
										map(res => res as any)
									),
									store.select(getData).pipe(
										skipWhile(v => !v.voucher),
										pluck('voucher'),
										take(1)
									)
								]).pipe(
									map(([job, voucher]) => {
										const decoderDetails = GetDecoderSerialNumberDisplay(voucher?.decoder_number);

										return {
											Decoder: {
												...decoderDetails,
												'Voucher Code': job?.job_information?.vouchers?.voucher_code ?? 'No additional decoder information',
												'Additional Decoder Info ': job?.job_information?.vouchers?.title ?? 'No additional decoder information'
											},
											'Replacement Device': { name: job?.office_use?.device_details?.replacement_device?.name }
										};
									})
								);
							}
						}
					}
				}
			}
		}
	}
};
